<template>
    <div>
        <canvas ref="canvas" />
    </div>
</template>

<script>
    import { Radar } from 'vue-chartjs'

    export default {
        name: 'RadarChart',
        extends: Radar,
        props: {
            playerData: {
                type: Object,
                required: true,
                default: () => ({
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    blockedShots: 0
                })
            },
            topStats: {
                type: Object,
                required: true,
                default: () => ({
                    points: { averageValue: 0 },
                    rebounds: { averageValue: 0 },
                    assists: { averageValue: 0 },
                    steals: { averageValue: 0 },
                    blocks: { averageValue: 0 }
                })
            }
        },
        data() {
            return {
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false // Hides the legend
                    },
                    scale: {
                        ticks: {
                            display: false, // Hides the scale text (numbers)
                            backdropColor: 'rgba(0, 0, 0, 0)' // Ensures no backdrop is shown
                        },
                        pointLabels: {
                            fontColor: 'white', // Set the color of the labels around the radar chart
                            fontSize: 13
                        },
                        gridLines: {
                            color: 'white' // Optional: Customize grid lines
                        },
                        angleLines: {
                            color: 'white' // Optional: Customize angle lines
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                const label = data.labels[tooltipItem.index] // Get the label from chartData.labels
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] // Get the value
                                return `${label}: ${value > 100 ? 100 : value} / 100` // Combine label and value
                            }
                        }
                    }
                },
                chartData: {
                    labels: [
                        'Pts',
                        'Reb',
                        'Ast',
                        'Stl',
                        'Blk'
                    ],
                    datasets: [
                        {
                            backgroundColor: 'rgba(173,235,179, 0.5)',
                            borderColor: '#ADEBB3',
                            pointBackgroundColor: '#f46257',
                            pointBorderColor: '#f46257',
                            pointHoverBackgroundColor: '#f72047',
                            pointHoverBorderColor: '#00CEC8',
                            data: [Math.round((this.playerData.points / this.topStats.points.averageValue) * 100 * 10) / 10, Math.round((this.playerData.rebounds / this.topStats.rebounds.averageValue) * 100 * 10) / 10, Math.round((this.playerData.assists / this.topStats.assists.averageValue) * 100 * 10) / 10, Math.round((this.playerData.steals / this.topStats.steals.averageValue) * 100 * 10) / 10, Math.round((this.playerData.blockedShots / this.topStats.blocks.averageValue) * 100 * 10) / 10]
                        }
                    ]
                }
            }
        },
        mounted() {
            // Render the chart with the provided data and options
            this.renderChart(this.chartData, this.chartOptions)
        }
    }
</script>
